import { DefaultService } from '@/services/DefaultService';

export default class AparelhoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(id, page = 0,order,column,limit = 50, filtros, ...param) {
        return this._http.post(encodeURI(`${this._env}/mobile/${id}.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${param}`), filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    changeSituacao(id, situacao) {
        return this._http.get(`${this._env}/mobile/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(obj) {
        return this._http.post(`${this._env}/mobile/activate/updatesituation`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findActive(id, order,column) {
        return this._http.get(encodeURI(`${this._env}/mobile/active/${id}.json?column=${column}&order=${order}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    qtdAparelhosAtivos(cliente_sovis_id = 0) {
        return this._http.get(`${this._env}/mobile/${cliente_sovis_id}/qtd-aparelhos-ativos.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}